import React, { Component } from 'react';
import ToggleSwitch from "@trendmicro/react-toggle-switch";
import TextInput from '../common/TextInput';

class InspectionRequired extends Component {
  constructor(props) {
    super(props);
  }
 
  render() {
    const {serviceInfo, checkInspection, onChangeToggleInsp, onInspecPriceChange} = this.props;
    return (
      <div className="inspection-main insp-auto-qoute"> 
      <div className="col-md-4 col-sm-8 col-xs-12 pad0">
         <span className="checkbox-style checkbox-wrapper"> 
             <span>
                  <input  type="checkbox" checked={serviceInfo.isinspectionrequired} id={`inspection-${serviceInfo.id}`} onChange={() =>
                    checkInspection(serviceInfo.id)} />
                    <label htmlFor={`inspection-${serviceInfo.id}`} className="custom-checkbox-2 custom-checkbox-subcat"></label>
              </span>
              <label htmlFor="inspection" className="subcategory-name ">
                 <span>Inspection Required</span>
               </label>                  
                { serviceInfo.isinspectionrequired &&<span className="inspection-payment pull-right">  Free
                      <ToggleSwitch
                        className="inspe-toggleSwitch"
                        checked={serviceInfo.paidInspection }
                        onChange={() => {
                          onChangeToggleInsp(serviceInfo.id);
                        }}
                         size="small"
                        ref={(node) => {
                          this.toggleSwitch = node;
                        }} />
                        Paid
                  </span>}
          </span>
        </div>
       { (serviceInfo.isinspectionrequired && serviceInfo.paidInspection) &&
        <div className="col-md-2 offset-md-2 col-sm-12  offset-xs-0 col-xs-12 pad0 inspection-qoute-auto">
            <div className="quotes-amount-card">
                 <TextInput
                   type="number"
                   name="price"
                   min="0"
                   value={serviceInfo.inspectionamount}
                   onChange={(amount) => onInspecPriceChange(amount,serviceInfo.id) } />
                 <span className="currency-tag">AED</span>
            </div>
            {(serviceInfo.isinspectionrequired && serviceInfo.inspectionamount === 0 && serviceInfo.paidInspection) &&
            <div><span className="error-inspection-text">Inspection amount Required</span></div>}
         </div>}
         
        </div>   
    );
  }
}

export default InspectionRequired;



// WEBPACK FOOTER //
// ./src/components/ManageServices/inspectionRequired.jsx